import { useEffect } from "react";
import { Outlet, useNavigate } from "@tanstack/react-router";
import { AdminSidebar } from "@/components/AdminSidebar";
import { UtilityBar } from "@/components/help/UtilityBar";
import { useAuth } from "@/lib/auth";

export function AdminLayout() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) navigate({ to: "/login" });
  }, [loading, user, navigate]);

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          fontFamily: "var(--f-mono)",
          fontSize: 11,
          letterSpacing: "0.14em",
          textTransform: "uppercase",
          color: "var(--ink-mute)",
        }}
      >
        Loading…
      </div>
    );
  }

  if (!user) return null;

  return (
    <div className="adm__shell">
      <UtilityBar />
      <div className="adm">
        <AdminSidebar />
        <div className="adm__main">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
